export * from './dataList'
export * from './localization'
export * from './canvasPreview'
export * from './cookie'
export * from './validations'

export const getLabelKeyPair = data =>
    data?.map(item => ({
        label: item,
        value: item
    }))
export const makeid = (length: number) => {
    let result = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const charactersLength = characters.length
    let counter = 0
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
        counter += 1
    }
    return result
}
export const sortOrder = (listSort, key) => (listSort === `-${key}` ? 'descend' : listSort === key ? 'ascend' : false)

export const getPlacementDirection = (placement, appDirection) => {
    let tooltipPlacement = placement
    if (appDirection === 'rtl') {
        if (placement === 'left') {
            tooltipPlacement = 'right'
        } else if (placement === 'right') {
            tooltipPlacement = 'left'
        } else if (placement === 'topLeft') {
            tooltipPlacement = 'topRight'
        } else if (placement === 'topRight') {
            tooltipPlacement = 'topLeft'
        } else if (placement === 'bottomLeft') {
            tooltipPlacement = 'bottomRight'
        } else if (placement === 'bottomRight') {
            tooltipPlacement = 'bottomLeft'
        }
    }
    return tooltipPlacement
}

export const openLink = (e, link) => {
    e.stopPropagation()
    e.preventDefault()
    window.open(link, '_blank', 'noreferrer')
}

export const getLocationSearch = () => {
    return window.location.search
        .replace('?', '')
        .split('&')
        .map(item => {
            const keyValue = item.split('=')
            return {
                key: keyValue[0],
                value: keyValue[1]
            }
        })
}

export const getCharacterColor = str => {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }

    const h = hash % 360
    return 'hsl(' + h + ', 30%, 80%)'
}
